import React, { useState, useEffect,forwardRef,useRef,useMemo,useCallback } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";
import * as Yup from "yup";
import { Formik } from "formik";
import { useFilePicker } from 'use-file-picker';
import {Select} from "@appkit4/react-components/select"
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import { Switch } from "@appkit4/react-components/switch";
import { TextArea } from "@appkit4/react-components/field";

import NewDateString from "../../../Common/newDateString.js";
import APIService from "../../../../services/apiAxiosService.js";
import useHttp from "../../../../hooks/useHttp.js";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic

export default function WorkProgramEdit(props) {
  const {
    WPRequestData,
    WorkProgramID,
    PlanId,
    RequestId,
    VendorId,
    View,
    role,
    AssessorId,
  } = props;

  

  const [modalVisible, setmodalVisible] = useState(false);
  const [managerCommentsFlag, setManagerCommentsFlag] = useState(false);
  const [managerStatus, setManagerStatus] = useState("");
  const [comments, setComments] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedTemplateTable, setSelectedTemplateTable] = useState([]);
  const [workProgramName, setWorkProgram] = useState([]);
  const [files, errors, openFileSelector, loading] = useFilePicker({
    multiple: false,
    accept: ".xlsx",
  });
  const [commentsFormat, setCommentsFormat] = useState(false);

  const [selectedType, setSelectedType] = useState(1);
  const [tableData, setTableData] = useState([]);
  const { sendRequest: getAllControlWorkProgramAPI } = useHttp();
  const { sendRequest: getAllFiles } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();

    const { sendRequest: updateWorkProgramRequest } = useHttp();
  const getWPRKeyValue = (key) => {
    if (WPRequestData && WPRequestData.length > 0) {
      return WPRequestData[0][key];
    }
    return "";
  };

  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  const InitialValues = {
    vendorName: getWPRKeyValue("vendorid"),
    workProgaramName: getWPRKeyValue("workprogramname"),
    previousAssessmentReport: getWPRKeyValue("statusid"),
    workProgram: JSON.parse(getWPRKeyValue("filename")),
    instructions: getWPRKeyValue("instructions"),
    workProgramType: getWPRKeyValue("workprogramcategory"),
    validityFrom: formatDate(getWPRKeyValue("validtill")),
    validityTo: formatDate(getWPRKeyValue("validfrom")),
  };

  const [gridApi, setGridApi] = useState(null);

  // Apply settings across all columns
  const defaultColDef = useMemo(() => ({
   // Enable filtering on all columns,
   // flex:1,
   sortable: true,
   cellDataType: false,
   wrapText: true,     
   autoHeight: true,  
 }));

 const onGridReady = (params) => {
   setGridApi(params.api);
 };

 

const onCellValueChanged = ((event) => {
  var data = event.data;
  const dataUpdate = [...tableData];
  const index = event.rowIndex;
  dataUpdate[index] = data;
  setTableData([...dataUpdate]);
});

  useEffect(() => {
    let tableData = JSON.parse(WPRequestData[0].category_data);
    let tableType = Object.keys(tableData[0]);
    let type = tableType.includes("Area");
    if (type) {
      setSelectedType(2);
    } else {
      setSelectedType(1);
    }

    setTableData(tableData);
    getFilesNames(getWPRKeyValue("workprogramcategory"));
    // setSelectedType(getWPRKeyValue("workprogramcategory"))
    getWorkPrograms();
  }, []);

  const getWorkPrograms = async () => {
    await getAllControlWorkProgramAPI(
      APIService.getAllControlWorkProgram(),
      (data) => setWorkProgram(data.MSG)
    );
  };

  const handleUpdate = async () => {
    let tableData1 = JSON.parse(JSON.stringify(tableData));

    let finalData = [];
    let keys = Object.keys(tableData1[0]);
    if (keys.includes("Domain")) {
      for (let i = 0; i < tableData1.length; i++) {
        let keys = Object.keys(tableData1[i]);
        if (keys.includes("Domain")) {
          //This checks for parent and if parent disabled, removed all its child.
          if (tableData1[i].domainToggle === true) {
            let subdomainInParentDisabled = 0;
            for (let j = i; j < tableData1.length; j++) {
              let keys1 = Object.keys(tableData1[j]);
              if (j !== i && keys1.includes("Domain")) {
                //Loops through the child, breaks if it reaches next parent.
                break;
              } else {
                // -----------------------------TO HANDEL SUB DOMAIN---------------------------------------------
                if (tableData1[j].subDomainToggle === true) {
                  let controlDomainInParentDisabled = 0;
                  if (subdomainInParentDisabled) {
                    //if previous domain child is disabled then next child will become parent
                    let updatedObject = JSON.parse(
                      JSON.stringify(tableData1[j])
                    );
                    updatedObject["S.No"] =
                      tableData[j - subdomainInParentDisabled]["S.No"];
                    updatedObject["Domain"] =
                      tableData[j - subdomainInParentDisabled]["Domain"];
                    updatedObject["domainToggle"] = true;

                    finalData.push(updatedObject);
                    subdomainInParentDisabled = 0;
                  } else {
                    // finalData.push(tableData1[j])
                    for (let k = j; k < tableData1.length; k++) {
                      let keys2 = Object.keys(tableData1[k]);
                      if (k !== j && keys2.includes("Sub Domain")) {
                        break;
                      } else {
                        if (tableData1[k].controlIDToggle === true) {
                          if (controlDomainInParentDisabled) {
                            let updatedObject = JSON.parse(
                              JSON.stringify(tableData1[k])
                            );
                            updatedObject["S.No Sub Domain"] =
                              tableData[k - controlDomainInParentDisabled][
                                "S.No Sub Domain"
                              ];
                            updatedObject["Sub Domain"] =
                              tableData[k - controlDomainInParentDisabled][
                                "Sub Domain"
                              ];
                            updatedObject["subDomainToggle"] = true;
                            finalData.push(updatedObject);
                            controlDomainInParentDisabled = 0;
                          } else {
                            finalData.push(tableData1[k]);
                          }
                        } else if (tableData1[j].subDomainToggle === true) {
                          controlDomainInParentDisabled =
                            controlDomainInParentDisabled + 1;
                          j++;
                        }
                      }
                    }
                  }
                } else if (tableData1[i].domainToggle === true) {
                  //hear domain is true and sub domain is false so need to push to new array.
                  subdomainInParentDisabled = subdomainInParentDisabled + 1;
                }
                //---------------------------------------------------------------------------
              }
            }
          }
        } else {
        }
      }
    } else {
      for (let i = 0; i < tableData1.length; i++) {
        let keys = Object.keys(tableData1[i]);
        if (keys.includes("Area")) {
          //This checks for parent and if parent disabled, removed all its child.
          if (tableData1[i].areaToggle === true) {
            let subdomainInParentDisabled = 0;
            for (let j = i; j < tableData1.length; j++) {
              let keys1 = Object.keys(tableData1[j]);
              if (j !== i && keys1.includes("Area")) {
                //Loops through the child, breaks if it reaches next parent.
                break;
              } else {
                // -----------------------------TO HANDEL SUB DOMAIN---------------------------------------------
                if (tableData1[j].subAreaToggle === true) {
                  let areaIDInParentDisabled = 0;
                  if (subdomainInParentDisabled) {
                    //if previous domain child is disabled then next child will become parent
                    let updatedObject = JSON.parse(
                      JSON.stringify(tableData1[j])
                    );
                    updatedObject["S.No"] =
                      tableData[j - subdomainInParentDisabled]["S.No"];
                    updatedObject["Area"] =
                      tableData[j - subdomainInParentDisabled]["Area"];
                    updatedObject[".areaToggle"] = true;
                    finalData.push(updatedObject);
                    subdomainInParentDisabled = 0;
                  } else {
                    // finalData.push(tableData1[j])

                    for (let k = j; k < tableData1.length; k++) {
                      let keys2 = Object.keys(tableData1[k]);
                      if (k !== j && keys2.includes("Sub Area")) {
                        break;
                      } else {
                        if (tableData1[k].questionIDToggle === true) {
                          if (areaIDInParentDisabled) {
                            let updatedObject = JSON.parse(
                              JSON.stringify(tableData1[k])
                            );
                            // updatedObject['S.No Sub Domain'] = tableData[k - areaIDInParentDisabled]['S.No Sub Domain']
                            updatedObject["Sub Area"] =
                              tableData[k - areaIDInParentDisabled]["Sub Area"];
                            updatedObject["subAreaToggle"] = true;
                            finalData.push(updatedObject);
                            areaIDInParentDisabled = 0;
                          } else {
                            finalData.push(tableData1[k]);
                          }
                        } else if (tableData1[j].subAreaToggle === true) {
                          areaIDInParentDisabled = areaIDInParentDisabled + 1;
                          j++;
                        }
                      }
                    }
                  }
                } else if (tableData1[j].areaToggle === true) {
                  //hear domain is true and sub domain is false so need to push to new array.
                  subdomainInParentDisabled = subdomainInParentDisabled + 1;
                }
                //---------------------------------------------------------------------------
              }
            }
          }
        } else {
        }
      }
    }

        let data = {
          email:sessionStorage.getItem("email"),

            paramvendorassessmentrequestid: RequestId,
            paramvendorassessmentplanid: PlanId,
            paramvendorid: VendorId,
            paramcomments: comments,
            paramroleid: Number(sessionStorage.getItem("roleId")),
            paramuserid: Number(sessionStorage.getItem("userId")),
            paramstatus: managerStatus,
            paramworkprogramid: WorkProgramID && WorkProgramID,
            paramCategoryData: JSON.stringify(tableData),
            paramFlag: "Work Program Comments"

        }
        updateWorkProgramRequest(APIService.updateWorkProgramRequest(data), responseHandler, errorHandler)
    }

    const responseHandler = (result) => {
        if(result.CODE[0].addmanagercomments) {
            if(result.MSG === "Approved") {
                let notifData = {
                    paramuserid: Number(sessionStorage.getItem("userId")),
                    paramreqid: parseInt(AssessorId),
                    paramcontent: "Approved work program",
                    paramnextroleid: 3,
                    paramcreatedby: Number(sessionStorage.getItem("roleId")),
                    parammsgtype: result.MSG
                }
                handleNotificationSubmitAPI(
                  APIService.handleNotificationSubmit(notifData),
                  () => {}
                );
                displayToastMessage("Work program approved successfully", "success")
                setmodalVisible(false)
                props.sendBack()
                setManagerCommentsFlag(false)
            }
            else if(result.MSG === "Rejected") {
                let notifData = {
                    paramuserid: Number(sessionStorage.getItem("userId")),
                    paramreqid: parseInt(AssessorId),
                    paramcontent: "Rejected work program",
                    paramnextroleid: 3,
                    paramcreatedby: Number(sessionStorage.getItem("roleId")),
                    parammsgtype: result.MSG
                }
                handleNotificationSubmitAPI(
                  APIService.handleNotificationSubmit(notifData),
                  () => {}
                );
                displayToastMessage("Work program rejected successfully", "success")
                setmodalVisible(false)
                props.sendBack()
                setManagerCommentsFlag(false)
            }
        }
        else {
            let MSG = "Something went wrong, Please try again!"
            displayToastMessage(MSG, "error")
        }
    }

    const errorHandler = () => {
        let MSG = "Something went wrong, Please try again!"
        displayToastMessage(MSG, "error")
    }

  const getFilesNames = async (arg) => {
    let type;
    if ((arg = 1)) {
      type = "domain";
    } else {
      type = "questionnaire";
    }
    getAllFiles(
      APIService.getAllFiles(type),
      (result) => {
        if (result.CODE) {
          let data = result.MSG;
          setSelectedFiles(data);
        }
      },
      errorHandler
    );
  };

  const validationSchema = Yup.object().shape({
    vendorName: Yup.string()
      .required("Third party name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    workProgaramName: Yup.string()
      .required("Work program name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    previousAssessmentReport: Yup.string()
      .required("Previous assessment report is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    workProgram: Yup.array().min(1).required("Work program is required"),
    instructions: Yup.string()
      .required("Instructions (if any) is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    workProgramType: Yup.string()
      .required("Work program type is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    validityFrom: Yup.string().required("Validity from is required"),
    validityTo: Yup.string().required("Validity to is required"),
  });

  const handleCancel = () => {
    setmodalVisible(false);
  };

  const handleStatus = (param) => {
    if (comments.trim().length > 0 && !commentsFormat) {
      setmodalVisible(true);
      setManagerStatus(param);
    } else {
      setManagerCommentsFlag(true);
    }
  };

  /* Formatting function for row details - modify as you need */
  function format(d) {
    // `d` is the original data object for the row
    return (
      '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
      "<tr>" +
      "<td >Full name:</td>" +
      "<td>" +
      "John" +
      "</td>" +
      "</tr>" +
      "<tr>" +
      "<td>Extra info:</td>" +
      "<td>And any further details here (images etc)...</td>" +
      "</tr>" +
      "</table>"
    );
  }

  // $(document).ready(function () {
  //   var table = $("#workProgramTable1").DataTable({
  //     initComplete: function (settings, json) {
  //       $(".dataTables_scrollBody thead tr").css({ visibility: "collapse" });
  //     },
  //     data: selectedTemplateTable,
  //     info: false,
  //     language: {
  //       paginate: {
  //         next: '<span class="appkiticon icon-right-chevron-fill"></span>', // or '→'
  //         previous: '<span class="appkiticon icon-left-chevron-fill"></span>', // or '←'
  //       },
  //     },
  //     destroy: true,
  //     columns: [
  //       {
  //         className: "details-control",
  //         orderable: false,
  //         data: null,
  //         defaultContent: "",
  //       },
  //       { data: "0" },
  //       {
  //         render: function (data, type, row) {
  //           return '<label class="switch1 mb-0"> <input type="checkbox" > <span class="slider round"></span></label>';
  //         },
  //       },
  //       { data: "2" },
  //       {
  //         render: function (data, type, row) {
  //           return '<label class="switch1 mb-0"> <input type="checkbox" > <span class="slider round"></span></label>';
  //         },
  //       },
  //       { data: "4" },
  //       { data: "5" },
  //       {
  //         render: function (data, type, row) {
  //           return '<label class="switch1 mb-0"> <input type="checkbox" > <span class="slider round"></span></label>';
  //         },
  //       },
  //     ],

  //     order: [[1, "asc"]],
  //   });

  //   // Add event listener for opening and closing details
  //   $("#workProgramTable1 tbody").on(
  //     "click",
  //     "td.details-control",
  //     function () {
  //       var tr = $(this).closest("tr");
  //       var row = table.row(tr);

  //       if (row.child.isShown()) {
  //         // This row is already open - close it
  //         row.child.hide();
  //         tr.removeClass("shown");
  //       } else {
  //         // Open this row
  //         row.child(format(row.data())).show();
  //         tr.addClass("shown");
  //       }
  //     }
  //   );
  // });

  let visibleToggle = (rowData, type) => {
    let keys = Object.keys(rowData);

    if (type === "Domain") {
      if (keys.includes("Domain") && keys.includes("Sub Domain")) {
        return true;
      } else {
        return false;
      }
    } else if (type === "subDomain") {
      if (keys.includes("Sub Domain")) {
        return true;
      } else {
        return false;
      }
    } else if (type === "area") {
      if (keys.includes("Area") && keys.includes("Sub Area")) {
        return true;
      } else {
        return false;
      }
    } else if (type === "subArea") {
      if (keys.includes("Sub Area")) {
        return true;
      } else {
        return false;
      }
    }
  };

  let handleCheckFieldValue = (rowData, type, value) => {
    let rowId = rowData?.rowIndex;
    let UpdatedTableDta = [...tableData];

    if (type === "domain") {
      let i;
      for (i = rowId; i < tableData.length; i++) {
        let keys = Object.keys(tableData[i]);
        if (keys.includes("Domain") && !(i === rowId)) {
          break;
        } else {
          UpdatedTableDta[i].domainToggle = value;
          UpdatedTableDta[i].subDomainToggle = value;
          UpdatedTableDta[i].controlIDToggle = value;
        }
      }
    } else if (type === "subDomain") {
      let i;
      //CHECKING FOR PARENT ON STATE(IF PARENT FALSE CHILD CAN NOT BE TRUE)
      if (value === true) {
        for (i = rowId; i >= 0; i--) {
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Domain")) {
            //CHECKING FOR PARENT
            if (UpdatedTableDta[i].domainToggle) {
              //CHECKING FOR PARENT STATE(ON/OFF)
              for (i = rowId; i < tableData.length; i++) {
                let keys = Object.keys(tableData[i]);
                if (keys.includes("Sub Domain") && !(i === rowId)) {
                  break;
                } else {
                  UpdatedTableDta[i].subDomainToggle = value;
                  UpdatedTableDta[i].controlIDToggle = value;
                  //     if(keys.includes("Sub Domain") ){//
                  //         UpdatedTableDta[i].subDomainToggle = value;
                  //         UpdatedTableDta[i].controlIDToggle = true;
                  //     }
                  //    else{UpdatedTableDta[i].controlIDToggle = false;}
                }
              }
            }
            break;
          }
        }
      } else {
        for (i = rowId; i < tableData.length; i++) {
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Sub Domain") && !(i === rowId)) {
            break;
          } else {
            UpdatedTableDta[i].subDomainToggle = value;
            UpdatedTableDta[i].controlIDToggle = value;
          }
        }
      }
    } else if (type === "controlID") {
      let i;
      if (value === true) {
        for (i = rowId; i >= 0; i--) {
          //LOOPS BACK FOR IT's PARENTS.
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Sub Domain")) {
            //CHECKING FOR PARENT
            if (UpdatedTableDta[i].subDomainToggle) {
              //CHECKING FOR PARENT STATE(ON/OFF)
              UpdatedTableDta[rowId].controlIDToggle = value;
            }
            break; //BREAKS WHEN IT REACHES TO IT'S PARENT(SUB DOMAIN).
          }
        }
      } else {
        let allChildStatus = false;

        let startIndex;
        for (let j = rowId; j >= 0; j--) {
          let keys = Object.keys(tableData[j]);
          if (keys.includes("Sub Domain")) {
            startIndex = j;
            break;
          }
        }
        let endIndex;
        for (let k = startIndex + 1; k < tableData.length; k++) {
          let keys = Object.keys(tableData[k]);
          if (keys.includes("Sub Domain")) {
            endIndex = k - 1;
            break;
          } else {
            endIndex = k;
          }
        }
        //WITH START AND END INDEX SEARCH FOR TRUE AND FALSE OF CONTROL ID, IF ALL DOMAINS ARE FALSE THEN SUB-DOMAINS WILL BE FALSE.
        for (let l = startIndex; l <= endIndex; l++) {
          if (l !== rowId && UpdatedTableDta[l].controlIDToggle === true) {
            allChildStatus = true;
            break;
          }
        }
        if (allChildStatus) {
          for (let l = startIndex; l <= endIndex; l++) {
            let keys = Object.keys(tableData[l]);
            if (keys.includes("Sub Domain")) {
              UpdatedTableDta[l].subDomainToggle = true;
            } else {
              UpdatedTableDta[l].subDomainToggle = true;
            }
          }
        } else {
          for (let l = startIndex; l <= endIndex; l++) {
            UpdatedTableDta[l].subDomainToggle = false;
          }
        }

        UpdatedTableDta[rowId].controlIDToggle = value; //THE SELECTED WILL BE FALSE
      }
    } else if (type === "area") {
      let i;
      for (i = rowId; i < tableData.length; i++) {
        let keys = Object.keys(tableData[i]);
        if (keys.includes("Area") && !(i === rowId)) {
          break;
        } else {
          UpdatedTableDta[i].areaToggle = value;
          UpdatedTableDta[i].subAreaToggle = value;
          UpdatedTableDta[i].questionIDToggle = value;
        }
      }
    } else if (type === "subArea") {
      let i;
      for (i = rowId; i < tableData.length; i++) {
        let keys = Object.keys(tableData[i]);
        if (keys.includes("Sub Area") && !(i === rowId)) {
          break;
        } else {
          UpdatedTableDta[i].subAreaToggle = value;
          UpdatedTableDta[i].questionIDToggle = value;
        }
      }
    } else if (type === "questionID") {
      // UpdatedTableDta[rowId].questionIDToggle = value;
      let i;
      if (value === true) {
        for (i = rowId; i >= 0; i--) {
          //LOOPS BACK FOR IT's PARENTS.
          let keys = Object.keys(tableData[i]);
          if (keys.includes("Sub Domain")) {
            //CHECKING FOR PARENT
            if (UpdatedTableDta[i].subDomainToggle) {
              //CHECKING FOR PARENT STATE(ON/OFF)
              UpdatedTableDta[rowId].controlIDToggle = value;
            }
            break; //BREAKS WHEN IT REACHES TO IT'S PARENT(SUB DOMAIN).
          }
          if (keys.includes("Question Id")) {
            //CHECKING FOR PARENT
            //CHECKING FOR PARENT STATE(ON/OFF)
            UpdatedTableDta[rowId].questionIDToggle = value;

            break; //BREAKS WHEN IT REACHES TO IT'S PARENT(SUB DOMAIN).
          }
        }
      } else {
        let allChildStatus = false;

        let startIndex;
        for (let j = rowId; j >= 0; j--) {
          let keys = Object.keys(tableData[j]);
          if (keys.includes("Sub Area")) {
            startIndex = j;
            break;
          }
        }
        let endIndex;
        for (let k = startIndex; k < tableData.length; k++) {
          let keys = Object.keys(tableData[k]);
          if (k != startIndex && keys.includes("Sub Area")) {
            endIndex = k;
            break;
          } else {
            endIndex = k;
          }
        }
        //WITH START AND END INDEX SEARCH FOR TRUE AND FALSE OF CONTROL ID, IF ALL DOMAINS ARE FALSE THEN SUB-DOMAINS WILL BE FALSE.
        for (let l = startIndex; l <= endIndex; l++) {
          if (l !== rowId && UpdatedTableDta[l].questionIDToggle === true) {
            allChildStatus = true;
            break;
          }
        }
        if (allChildStatus) {
          for (let l = startIndex; l <= endIndex; l++) {
            let keys = Object.keys(tableData[l]);
            if (keys.includes("Sub Area")) {
              UpdatedTableDta[l].subAreaToggle = true;
            } else {
              UpdatedTableDta[l].subAreaToggle = true;
            }
          }
        } else {
          for (let l = startIndex; l <= endIndex; l++) {
            UpdatedTableDta[l].subAreaToggle = false;
          }
        }

        UpdatedTableDta[rowId].questionIDToggle = value; //THE SELECTED WILL BE FALSE
      }
    }
    setTableData(UpdatedTableDta);
  };

  const handleChangeComment = (e) => {
    if (e.search(/[^()0-9a-zA-Z,. ]/) === -1) {
      setCommentsFormat(false);
    } else {
      setComments();
      setCommentsFormat(true);
    }
    setComments(e);
  };

  const rowStyle = { background: 'white' };


  return (
    <div className="App">
      <Formik initialValues={InitialValues} validationSchema={validationSchema}>
        {(prop) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting,
          } = prop;
          return (
            <form onSubmit={handleSubmit}>
              <div className="row mt-5">
                <div className="col-sm-6">
                  <div className="cv-input-field-container-disabled pt-0 pb-0">
                    <label className="cv-input-label">
                      Third Party Name
                      <span className="asterisk-required">*</span>
                    </label>
                    <Select
                      className="cv-input-field"
                      value={values.vendorName}
                      data={props.vendors}
                      labelKey="vendor_name"
                      valueKey="vendor_id"
                      name="Third Party Name"
                      placeholder="Select Third Party Name"
                      disabled
                    ></Select>
                  </div>
                  {errors.vendorName && touched.vendorName && (
                    <div className="form-label error">{errors.vendorName}</div>
                  )}
                </div>
                <div className="col-sm-6">
                  <div className="cv-input-field-container-disabled pt-0 pb-0">
                    <label className="cv-input-label">
                      Work Program Name
                      <span className="asterisk-required">*</span>
                    </label>

                    <Select
                      showSearchOnToggle={true}
                      className="cv-input-field"
                      data={workProgramName}
                      valueKey="workprogram_id"
                      labelKey="work_program_name"
                      value={Number(values.workProgaramName)}
                      name="Third Party Name"
                      placeholder="Select work program Name"
                      disabled
                    ></Select>
                  </div>
                  {errors.workProgaramName && touched.workProgaramName && (
                    <div className="form-label error">
                      {errors.workProgaramName}
                    </div>
                  )}
                </div>
              </div>

              <div className="row ">
                <div className="col-sm-6">
                  <div className="cv-input-field-container-disabled">
                    <label htmlFor="validityFromWPEdit" className="cv-input-label">
                      Validity From<span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field-disabled pl-2"
                      type="date"
                      id="validityFromWPEdit"
                      name="validity From"
                      onBlur={handleBlur}
                      value={values.validityTo}
                      min={NewDateString()}
                      onChange={handleChange("validityTo")}
                      disabled={true}
                    />
                  </div>
                  {errors.validityTo && touched.validityTo && (
                    <div className="form-label error">{errors.validityTo}</div>
                  )}
                </div>

                <div className="col-sm-6">
                  <div className="cv-input-field-container-disabled">
                    <label htmlFor="validityToWPEdit" className="cv-input-label">
                      Validity To<span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field-disabled pl-2"
                      type="date"
                      id="validityToWPEdit"
                      name="LastAssessmentDate"
                      onBlur={handleBlur}
                      value={values.validityFrom}
                      min={NewDateString(values.validityFrom)}
                      onChange={handleChange("validityFrom")}
                      disabled={true}
                      //onBlurCapture={change.bind(null, 'lastAssessmentDate')}
                    />
                  </div>
                  {errors.validityFrom && touched.validityFrom && (
                    <div className="form-label error">
                      {errors.validityFrom}
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="cv-input-field-container-disabled pt-0 pb-0">
                    <label htmlFor="instructionsWPEdit" className="cv-input-label">
                      Instructions (if any)
                      <span className="asterisk-required">*</span>
                    </label>
                    <input
                      className="cv-input-field-disabled pl-2"
                      onBlur={handleBlur}
                      id="instructionsWPEdit"
                      type="text"
                      value={values.instructions}
                      placeholder="Please enter instructions"
                      onChange={handleChange("instructions")}
                      name="Instructions"
                      disabled={true}
                    />
                  </div>
                  {errors.instructions && touched.instructions && (
                    <div className="form-label error">
                      {errors.instructions}
                    </div>
                  )}
                </div>
              </div>
              <div className="row pt-5 pl-3 pr-3">
                <div className="col-lg-12 mt-3 pl-1">
                <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                          <AgGridReact
                            rowStyle={rowStyle}

                            rowData={tableData}
                            columnDefs={selectedType==1 ?
                              [
                                {
                                  headerName: "Select",
                                  field: "Select",
                                  cellRenderer: (rowData) =>
                                  visibleToggle(rowData.data, "Domain") && (
                                    <Switch
                                      checked={rowData.data.domainToggle}
                                      onChange={(e) =>
                                        handleCheckFieldValue(
                                          rowData,
                                          "domain",
                                          e
                                        )
                                      }
                                    ></Switch>
                                  ),
                                }, {
                                  headerName: "S.No",
                                  field: "S.No",
                                }, {
                                  headerName: "Domain",
                                  field: "Domain",
                                  editable:true,
                                }, {
                                  headerName: "Select",
                                  field: "Select",
                                  cellRenderer: (rowData) =>
                                  visibleToggle(rowData.data, "subDomain") && (
                                    <Switch
                                      checked={rowData.data.subDomainToggle}
                                      onChange={(e) =>
                                        handleCheckFieldValue(
                                          rowData,
                                          "subDomain",
                                          e
                                        )
                                      }
                                    ></Switch>
                                  ),
                                },{
                                  headerName: "S.No",
                                  field: "S.No Sub Domain",
                                  
                                },{
                                  headerName: "Sub Domain",
                                  field: "Sub Domain",
                                  editable:true,

                                 
                                },
                                { headerName: "Select", field: "Select", cellRenderer: (rowData) => (
                                  <Switch
                                    checked={rowData.data.controlIDToggle}
                                    onChange={(e) =>
                                      handleCheckFieldValue(
                                        rowData,
                                        "controlID",
                                        e
                                      )
                                    }
                                  ></Switch>
                                ), },
                                
                                {
                                  headerName: "Control ID",
                                  field: "Control ID",
                                  editable:true,

                                 
                                }, {
                                  headerName: "Control Definition",
                                  field: "Control Definition",
                                  editable:true,

                                 
                                }, {
                                  headerName: "Control Testing Procedure",
                                  field: "Control Testing Procedure",
                                  editable:true,

                                 
                                },{
                                  headerName: "Attachment required",
                                  field: "Attachment required",
                                  editable:true,

                                 
                                },{
                                  headerName: "Attachment Type",
                                  field: "Attachment Type",
                                  editable:true,

                                },]:[
                              {
                                headerName: "Select",
                                field: "Select",
                                editable: true,
                                cellDataType:'boolean',
                                cellRenderer: (rowData) =>
                                visibleToggle(rowData.data, "area") && (
                                  <Switch
                                    checked={rowData.data.areaToggle}
                                    onChange={(e) =>
                                      handleCheckFieldValue(
                                        rowData,
                                        "area",
                                        e
                                      )
                                    }
                                  ></Switch>
                                ),
                              },
                              { headerName: "S.No", field: "S.No"},
                              { headerName: "Area", field: "Area", editable: true },
                              { headerName: "Select",field: "Select",editable: true, cellRenderer: (rowData) =>
                              visibleToggle(rowData.data, "subArea") && (
                                <Switch
                                  checked={rowData.data.subAreaToggle}
                                  onChange={(e) =>
                                    handleCheckFieldValue(
                                      rowData,
                                      "subArea",
                                      e
                                    )
                                  }
                                ></Switch>
                              ),},
                              { headerName: "Sub Area",field: "Sub Area",editable: true},
                              { headerName: "Select", field: "Select",editable: true, cellRenderer: (rowData) => (
                                <Switch
                                  checked={rowData.data.questionIDToggle}
                                  onChange={(e) =>
                                    handleCheckFieldValue(
                                      rowData,
                                      "questionID",
                                      e
                                    )
                                  }
                                ></Switch>
                              ),
                              },
                              { headerName: "Question Id", field: "Question Id",editable: true },
                                                          { headerName: "Question", field: "Question",editable: true,width:400,cellEditor: "agLargeTextCellEditor",cellEditorPopup: true ,cellEditorParams: {
                                                            maxLength: 500
                                                        },},
                                                          {
                                                            headerName: "Instructions (If any)",
                                                            field: "Instructions (If any)",
                                                            editable: true,width:400,cellEditor: "agLargeTextCellEditor",cellEditorPopup: true,cellEditorParams: {
                                                              maxLength: 500
                                                          },
                                                          },
                                                          {
                                                            headerName: "Attachment required",
                                                            field: "Attachment required",
                                                            editable: true
                                                          },
                                                          {
                                                            headerName: "Attachment Type",
                                                            field: "Attachment Type",
                                                            editable: true
                                                          },
                             
                              
                            ]}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            onCellValueChanged={onCellValueChanged}
                            onGridReady={onGridReady}
                          />
                          </div>
                </div>
                {role === "admin" ? (
                  ""
                ) : (
                  <div>
                    <div className="row mt-3">
                      <div className="col-sm-12">
                        <div className="">
                          <label className="cv-input-label">
                            Manager Comments
                            <span className="asterisk-required">*</span>
                          </label>
                          <TextArea
                            className="cv-input-field input-field-border"
                            type="text"
                            value={comments}
                            onChange={handleChangeComment}
                            name="comments"
                            placeholder="Please Add comment."
                          />
                          {comments === "" && managerCommentsFlag && (
                            <label className="requiredComments">
                              Please enter comments
                            </label>
                          )}
                          {commentsFormat && (
                            <label className="requiredComments">
                              Only alphabets and some special characters are
                              allowed for this field
                            </label>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="options-container float-left">
                      {View && View && (
                        <button
                          disabled={isSubmitting}
                          className="save-button"
                          onClick={() => handleStatus("Approved")}
                        >
                          Approve
                        </button>
                      )}
                      {View && View && (
                        <button
                          disabled={isSubmitting}
                          className="save-button m-l-2"
                          onClick={() => handleStatus("Rejected")}
                        >
                          Reject
                        </button>
                      )}
                      <button
                        className="cancel-button m-l-2"
                        type="reset"
                        onClick={props.sendBack}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </form>
          );
        }}
      </Formik>
      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={modalVisible}
          onCancel={handleCancel}
          bodyStyle={{ maxHeight: "280px" }}
          footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
          modalStyle={{ width: "49.75rem", maxHeight: "fit-content" }}
        >
          Are you sure you want to Process the Request?
          <ModalFooter>
            <button
              type="button"
              className="cancel-button"
              onClick={handleCancel}
            >
              No
            </button>

            <button
              type="submit"
              className="save-button m-l-2"
              onClick={handleUpdate}
            >
              Yes
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}
